import "./legal.css";

export function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <a href="/" className="back-link">&larr; Back to Home</a>

        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: February 1, 2026</p>

        <section>
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing or using the Kris & Heejin website at{" "}
            <a href="https://krisandheejin.com">https://krisandheejin.com</a> (the "Site"),
            you agree to be bound by these Terms of Service ("Terms"). If you do not agree
            to these Terms, please do not use our Site.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Kris & Heejin provides a personal website and associated services. We reserve
            the right to modify, suspend, or discontinue any aspect of the Site at any time
            without notice.
          </p>
        </section>

        <section>
          <h2>3. User Accounts</h2>
          <p>
            Some features of our Site may require you to create an account or sign in using
            a third-party service such as Google. You are responsible for:
          </p>
          <ul>
            <li>Maintaining the confidentiality of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us immediately of any unauthorized use</li>
          </ul>
          <p>
            You must provide accurate and complete information when creating an account.
            We reserve the right to suspend or terminate accounts that violate these Terms.
          </p>
        </section>

        <section>
          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Site for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to any part of the Site</li>
            <li>Interfere with or disrupt the Site or servers</li>
            <li>Upload or transmit viruses or malicious code</li>
            <li>Collect user information without consent</li>
            <li>Impersonate any person or entity</li>
            <li>Use automated systems to access the Site without permission</li>
          </ul>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>
          <p>
            All content on the Site, including text, graphics, logos, images, and software,
            is the property of Kris & Heejin or its content suppliers and is protected by
            intellectual property laws. You may not reproduce, distribute, modify, or create
            derivative works without our prior written consent.
          </p>
        </section>

        <section>
          <h2>6. User Content</h2>
          <p>
            If you submit any content to the Site, you grant us a non-exclusive, worldwide,
            royalty-free license to use, reproduce, modify, and display such content in
            connection with operating the Site. You represent that you have all necessary
            rights to grant this license.
          </p>
        </section>

        <section>
          <h2>7. Third-Party Services</h2>
          <p>
            Our Site may integrate with third-party services (such as Google for
            authentication). Your use of these services is subject to their respective
            terms and privacy policies. We are not responsible for the practices of
            third-party services.
          </p>
        </section>

        <section>
          <h2>8. Disclaimer of Warranties</h2>
          <p>
            THE SITE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND,
            EITHER EXPRESS OR IMPLIED. WE DISCLAIM ALL WARRANTIES, INCLUDING IMPLIED
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SITE WILL BE UNINTERRUPTED,
            SECURE, OR ERROR-FREE.
          </p>
        </section>

        <section>
          <h2>9. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, KRIS & HEEJIN SHALL NOT BE LIABLE FOR
            ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING
            FROM YOUR USE OF THE SITE. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU
            PAID US, IF ANY, IN THE PAST 12 MONTHS.
          </p>
        </section>

        <section>
          <h2>10. Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless Kris & Heejin, its affiliates, and
            their respective officers, directors, employees, and agents from any claims,
            damages, losses, or expenses arising from your use of the Site or violation
            of these Terms.
          </p>
        </section>

        <section>
          <h2>11. Termination</h2>
          <p>
            We may terminate or suspend your access to the Site at any time, without prior
            notice, for any reason, including violation of these Terms. Upon termination,
            your right to use the Site will cease immediately.
          </p>
        </section>

        <section>
          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify you of
            significant changes by posting the new Terms on this page and updating the
            "Last updated" date. Your continued use of the Site after changes constitutes
            acceptance of the modified Terms.
          </p>
        </section>

        <section>
          <h2>13. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of
            the United States, without regard to conflict of law principles.
          </p>
        </section>

        <section>
          <h2>14. Severability</h2>
          <p>
            If any provision of these Terms is found to be unenforceable, the remaining
            provisions will continue in full force and effect.
          </p>
        </section>

        <section>
          <h2>15. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:support@krisandheejin.com">support@krisandheejin.com</a>
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a href="https://krisandheejin.com">https://krisandheejin.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}